// extracted by mini-css-extract-plugin
export default {"dialogContainer":"styles_dialogContainer__2TIDT","dialog":"styles_dialog__t8JYi","dialogContent":"styles_dialogContent__iVyQH","connectBtn":"styles_connectBtn__OHlWF"};